import { render } from "./Loginnew.vue?vue&type=template&id=6c42a451&scoped=true"
import script from "./Loginnew.vue?vue&type=script&lang=js"
export * from "./Loginnew.vue?vue&type=script&lang=js"

import "./Loginnew.vue?vue&type=style&index=0&id=6c42a451&scoped=true&lang=css"

import exportComponent from "/Volumes/work/mywork/selecthouse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c42a451"]])

export default __exports__